import { Flex, Img } from "@givenwell/components";
import { colors } from "@givenwell/theme";
import { createFileRoute } from "@tanstack/react-router";
import img from "./footer-B.png";

export const Route = createFileRoute("/_auth/_app/messages/")({
  component: Page,
});

function Page() {
  return (
    <Flex
      css={{
        flexDirection: "column",
        items: "center",
        justify: "center",
        height: "100%",
        width: "100%",
        fontScale: "sm",
        color: colors.text2,
        gap: 16,
      }}
    >
      <Img src={img} css={{ width: 110 }} />
      Select a message to read
    </Flex>
  );
}
